import React from "react";
import { useFeatureFlagsContext } from "@/hooks/useFeatureFlag";
import { ALWAYS_ON_KEYS } from "@/constants/featureRegistry";

/**
 * FeatureSectionGuard — reusable component-level feature gate.
 *
 * Semantik STRICT FAIL-CLOSED (khusus untuk section premium):
 *   - loading  → tidak render (fail-closed) supaya UI premium tidak "flash"
 *   - error    → tidak render (fail-closed); backend gate 403 tetap pertahanan akhir
 *   - unknown  → tidak render
 *   - disabled → render fallback (default: null) supaya:
 *       - API tidak dipanggil (children tidak mount)
 *       - State tidak dipertahankan (children unmount penuh)
 *       - Tidak ada leakage credential / action premium
 *
 * Beda dengan FeatureRouteGuard:
 *   - Route guard: pakai spinner + fallback upsell → aman untuk full-page block.
 *   - Section guard: SILENT hide → tidak boleh render skeleton yang bocor.
 */
export default function FeatureSectionGuard({ featureKey, children, fallback = null }) {
  const { features, loading, error } = useFeatureFlagsContext();
  if (!featureKey) return children;
  if (ALWAYS_ON_KEYS.includes(featureKey)) return children;
  if (loading) return fallback;
  if (error) return fallback;
  const f = features[featureKey];
  if (f && f.enabled) return children;
  return fallback;
}
